export default "<p>pich-personal-modal works!</p>\n";